<template>
  <div id="helpButton"></div>
</template>

<script>

export default {
  name: 'app-helpButton',
  mounted() {
    const helpButton = document.getElementById('helpButton');
    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = 'https://static.zdassets.com/ekr/snippet.js?key=39ed71c7-81ad-40f4-9fbb-be188f19702f';
    helpButton.appendChild(script);
  },
};

</script>
